<template>

  <div>

    <v-dialog v-model="show" max-width="500px">

      <v-card class="mx-auto">
        <v-card-text class="text-xs-left">

          <v-layout row align-center>
            <div class="mb-1 plan-title">{{ plan.name }}</div>
            <v-spacer></v-spacer>
            <v-btn flat icon color="itoviGrayMid" @click="show=false"><v-icon>close</v-icon></v-btn>
          </v-layout>

          <v-divider class="mt-2 mb-2"></v-divider>

          <div class="mb-2">{{ plan.details.description }}</div>

          <v-layout align-center row wrap>
            <span class="txt-bold">Monthly:&nbsp;</span>
            <span class="txt-bold">${{ formatPrice(plan.monthly) }}</span>
            <span class="txt-bold"
                  style="font-size: 7pt;">&nbsp;/ mo</span>
          </v-layout>




          <!--      what's included section          -->
          <div v-if="!!plan.details.included && plan.details.included.length > 0" class="mt-2">
            <!--                <h4>What's included:</h4>-->
            <ul>
              <template v-for="(updradeDetailsIncludedItem, index2) in plan.details.included">
                <li :key="index2">{{ updradeDetailsIncludedItem }}</li>
              </template>
            </ul>
          </div>

        </v-card-text>
      </v-card>

    </v-dialog>
  </div>

</template>

<style lang="scss" scoped>
  .plan-title {
    font-size: 15pt;
    color: #027689;
  }
</style>

<script>

  export default {
    components: {
    },
    data: ()=> ({
      showLoadingDialog: false,
    }),
    props: {
      value: {
        type: Boolean,
        default: false
      },
      plan: {
        type: Object,
        default: () => ({
          id: 0,
          name: '',
          price: 0,
          monthly: 0,
          details: {
            included: [],
            description: null,
          }
        })
      },
    },
    created() {
      // console.log(this.plan)
    },
    methods: {
      isFunction(functionToCheck) {
        return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2)
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },
    },
    computed: {
      show: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit('input', value)
        }
      }
    }
  }
</script>
